// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from 'firebase/app'

// Add the Firebase products that you want to use
import 'firebase/auth'
import 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyB9tbzy8Ls6o2SuqMJvVpx39sFP8hElVnk',
  authDomain: 'testcovid-358e3.firebaseapp.com',
  databaseURL: 'https://testcovid-358e3.firebaseio.com',
  projectId: 'testcovid-358e3',
  storageBucket: 'testcovid-358e3.appspot.com',
  messagingSenderId: '968515018341',
  appId: '1:968515018341:web:5520cf82d8a48a72d7308c',
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

export default firebase
